import React, { PureComponent } from 'react'
import { func, shape, string } from 'prop-types'
import Input from '@active/react-ui/Input'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import FormField from '@active/react-ui/FormField'
import Form, { FormConsumer } from '@active/react-ui/Form'
import { AddressEditor } from '@active/react-address-editor'
import { Locale } from '@active/react-utils/i18n'
import noop from 'lodash/noop'
import './BillingAddress.scss'

export const addressFieldsConfig = {
  country: { autoComplete: 'country' },
  city: { autoComplete: 'city' },
  line1: { autoComplete: 'address-line1' },
  line2: { autoComplete: 'address-line2' },
  stateProvince: { autoComplete: 'province' },
  postalCode: { autoComplete: 'postal-code' },
}
class BillingAddress extends PureComponent {
  static propTypes = {
    getBillingAddressCallBack: func.isRequired,
    defaultValues: shape({
      billingFirstName: string,
      billingLastName: string,
      address: shape({
        country: string,
        line1: string,
        line2: string,
        city: string,
        stateProvince: string,
        postalCode: string,
      }),
    }),
    submitTrigger: func,
  }

  static defaultProps = {
    defaultValues: {
      billingFirstName: '',
      billingLastName: '',
      address: {
        country: '',
        line1: '',
        line2: '',
        city: '',
        stateProvince: '',
        postalCode: '',
      },
    },
    submitTrigger: noop,
  }

  submitFormTrigger = noop

  componentDidMount() {
    const { submitTrigger } = this.props
    submitTrigger(this.submitFormTrigger)
  }

  handleSubmit = values => {
    const { getBillingAddressCallBack } = this.props
    getBillingAddressCallBack(values)
  }

  handleSubmitFailed = () => {
    const { getBillingAddressCallBack } = this.props
    getBillingAddressCallBack({ errorCode: 'BILLINGADDRESS_INVALID_PARAMS' })
  }

  handleSubmitError = () => {
    const { getBillingAddressCallBack } = this.props
    getBillingAddressCallBack({ errorCode: 'BILLINGADDRESS_INVALID_PARAMS' })
  }

  render() {
    const { defaultValues } = this.props
    return (
      <div className="checkout-payments checkout__billingAddress">
        <h2 className="checkout-payments__title">
          <Locale id="passport.lib.components.billingAddress.title" />
        </h2>
        <Form
          horizontal
          trimInput
          onSubmit={this.handleSubmit}
          onInvalid={this.handleSubmitFailed}
          onError={this.handleSubmitError}// TODO: whether onFail is onError or onInvalid
          initialValues={defaultValues}
        >
          <FormGroup name="billingFirstName" required>
            <FormLabel><Locale id="passport.lib.components.billingAddress.label.firstName" /></FormLabel>
            <FormField as={Input} maxLength={255} autoComplete="given-name" />
          </FormGroup>
          <FormGroup name="billingLastName" required>
            <FormLabel><Locale id="passport.lib.components.billingAddress.label.lastName" /></FormLabel>
            <FormField as={Input} maxLength={255} autoComplete="family-name" />
          </FormGroup>
          <AddressEditor required name="address" fieldsConfig={addressFieldsConfig} />
          <FormConsumer>
            {({ form: { submitForm } }) => {
              this.submitFormTrigger = submitForm
              return null
            }}
          </FormConsumer>
        </Form>
      </div>
    )
  }
}

export default BillingAddress
